/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MailMagazineManagementDeleteMailMagazineResponse } from './MailMagazineManagementDeleteMailMagazineResponse';

export type MailMagazineManagementDeleteMailMagazineResponseApiRespoonse = {
    data?: MailMagazineManagementDeleteMailMagazineResponse;
    status?: MailMagazineManagementDeleteMailMagazineResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace MailMagazineManagementDeleteMailMagazineResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

